import { render, staticRenderFns } from "./LegendContainer.vue?vue&type=template&id=0e1460fa&scoped=true&"
import script from "./LegendContainer.vue?vue&type=script&lang=js&"
export * from "./LegendContainer.vue?vue&type=script&lang=js&"
import style0 from "./LegendContainer.vue?vue&type=style&index=0&id=0e1460fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1460fa",
  null
  
)

export default component.exports